import React, { Component } from 'react';
import { TouchableOpacity, Text, Modal, View } from 'react-native';
import styles from './style';

interface Props {
    isVisible: boolean;
    title?: string;
    btnText: string;
    content: string;
    accessLabelInfo?: object;
    onOk?(): void;
    onCancel?(): void;
}

class Alert extends Component<Props> {
    // public onMaskTap = () => {};

    public render() {
        const { isVisible, onOk, onCancel, title, btnText, content, accessLabelInfo={} } = this.props;
        return (
            <Modal
                visible={isVisible}
                transparent
                hardwareAccelerated
                animationType="fade"
                onRequestClose={() => onCancel?.()}
            >
                <View style={styles.dialogWrapper}>
                    <View style={styles.dialog}>
                        {Boolean(title) && (
                            <View style={styles.dialogHead}>
                                <Text style={styles.dialogHeadText}>{title}</Text>
                            </View>
                        )}
                        {Boolean(content) && (
                            <View style={styles.dialogContent}>
                                <Text style={styles.dialogContentText}>{content}</Text>
                            </View>
                        )}
                        <TouchableOpacity
                            activeOpacity={1}
                            style={styles.dialogFoot}
                            onPress={() => onOk?.()}
                            accessible={false}
                            {...accessLabelInfo}
                        >
                            <Text style={styles.dialogBtn}>{btnText}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </Modal>
        );
    }
}

export default Alert;
